// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    development: true,
    baseSite: ['bhp'],
    language: ['en'],
    currency: ['USD'],
    enableReload:true,
    // china tenent
    // baseUrl  : 'https://api.cyow1l4vxv-bhpbillit1-d1-public.model-t.ccv2prod.sapcloud.cn/',
    // baseUrl: 'backofficebhpconnect.jsapps.cyow1l4vxv-bhpbillit1-d1-public.model-t.ccv2prod.sapcloud.cn',

    // global tenent
    baseUrl  : 'https://api.c6kcpohdh5-bhpgroupo1-d1-public.model-t.cc.commerce.ondemand.com/',

    CDCLoginUrl: 'https://cdns.au1.gigya.com/js/gigya.js?apikey=4_m988MAyjJlNIW6vXA5B1Wg'
  };

  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

